import React, { useState, useEffect } from 'react';
import { reload, signOut } from 'firebase/auth';
import { Link } from 'react-router-dom';
import { auth } from '../firebase';
import { sendVerificationEmail } from '../api';
import './Login.css';

export default function EmailVerification({ nutzer }) {
  const [senden, setSenden]   = useState(false);
  const [erfolg, setErfolg]   = useState(false);
  const [fehler, setFehler]   = useState(false);
  const [pruefen, setPruefen] = useState(false);

  // Poll every 3 s — reload token and check emailVerified
  useEffect(() => {
    const id = setInterval(async () => {
      if (!auth.currentUser) return;
      await reload(auth.currentUser);
      if (auth.currentUser.emailVerified) {
        await auth.currentUser.getIdToken(true);
        clearInterval(id);
        window.location.reload();
      }
    }, 3000);
    return () => clearInterval(id);
  }, []);

  const erneutSenden = async () => {
    setSenden(true);
    setFehler(false);
    try {
      await auth.currentUser?.getIdToken(true);
      await sendVerificationEmail();
      setErfolg(true);
      setTimeout(() => setErfolg(false), 6000);
    } catch {
      setFehler(true);
    }
    setSenden(false);
  };

  const manuellPruefen = async () => {
    setPruefen(true);
    await reload(auth.currentUser);
    if (auth.currentUser.emailVerified) {
      await auth.currentUser.getIdToken(true);
      window.location.reload();
      return;
    }
    setPruefen(false);
  };

  return (
    <div className="auth-root">
      {/* Brand Panel */}
      <div className="auth-brand">
        <div className="auth-logo">
          <img src="/logo.png" alt="CVFlow" className="auth-logo-mark" />
          <span className="auth-logo-text">CVFlow</span>
        </div>
        <div className="auth-brand-center">
          <h2 className="auth-brand-headline">Fast geschafft!</h2>
          <p className="auth-brand-sub">
            Nur noch ein kleiner Schritt, dann kann es losgehen.
          </p>
        </div>
        <div className="auth-brand-footer">
          Made in Germany ·{' '}
          <Link to="/datenschutz" style={{ color: 'inherit', textDecoration: 'underline' }}>Datenschutz</Link>
        </div>
      </div>

      {/* Form Panel */}
      <div className="auth-form-panel">
        <div className="auth-form-inner" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 60, marginBottom: 28, lineHeight: 1 }}>📬</div>

          <h1 className="auth-heading" style={{ textAlign: 'center' }}>
            E-Mail bestätigen
          </h1>
          <p className="auth-subheading" style={{ textAlign: 'center' }}>
            Wir haben eine Bestätigungs-E-Mail an{' '}
            <strong style={{ color: 'var(--txt-primary)' }}>{nutzer.email}</strong>{' '}
            geschickt. Klicke auf den Link in der E-Mail.
          </p>

          {erfolg && (
            <div className="auth-success">
              E-Mail erneut gesendet! Bitte überprüfe dein Postfach.
            </div>
          )}

          {fehler && (
            <div className="auth-error">
              Die E-Mail konnte gerade nicht gesendet werden. Bitte versuche es gleich erneut.
            </div>
          )}

          <button
            className="auth-submit"
            onClick={manuellPruefen}
            disabled={pruefen}
            style={{ marginBottom: 12 }}
          >
            {pruefen ? <span className="auth-spinner" /> : 'Ich habe bestätigt ✓'}
          </button>

          <button
            className="auth-google"
            onClick={erneutSenden}
            disabled={senden}
            style={{ marginBottom: 24 }}
            type="button"
          >
            {senden ? 'Sende...' : 'E-Mail erneut senden'}
          </button>

          <div className="auth-link-row">
            <button className="auth-link" onClick={() => signOut(auth)}>
              Mit anderem Konto anmelden
            </button>
          </div>

          <p style={{ marginTop: 28, fontSize: 12, color: 'var(--txt-faint)', fontFamily: 'DM Sans, sans-serif', lineHeight: 1.5 }}>
            Die Seite leitet dich automatisch weiter, sobald deine E-Mail bestätigt wurde.
          </p>
        </div>
      </div>
    </div>
  );
}
